// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___Fae4W","m-signature-pad--body":"styles__m-signature-pad--body___3K-8U","m-signature-pad--footer":"styles__m-signature-pad--footer___25ZNi","description":"styles__description___2xcNW","button":"styles__button___37xg_","clear":"styles__clear___3LKGn","save":"styles__save___34qGV","m-signature-pad":"styles__m-signature-pad___2SMR3","github":"styles__github___2hU1C","wrapper":"styles__wrapper___2w8Fy","contentWrapper":"styles__contentWrapper___1Xacz","content":"styles__content___3okaI","medalImg":"styles__medalImg___1wxPR"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/ProfitMargin/styles.scss
// module id = xqJT
// module chunks = client